import React__default from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(
  (theme) => ({
    node: {
      fill: theme.palette.primary.light,
      stroke: theme.palette.primary.light
    },
    text: {
      fill: theme.palette.primary.contrastText
    }
  }),
  { name: "BackstageDependencyGraphDefaultNode" }
);
function DefaultNode({ node: { id } }) {
  const classes = useStyles();
  const [width, setWidth] = React__default.useState(0);
  const [height, setHeight] = React__default.useState(0);
  const idRef = React__default.useRef(null);
  React__default.useLayoutEffect(() => {
    if (idRef.current) {
      let { height: renderedHeight, width: renderedWidth } = idRef.current.getBBox();
      renderedHeight = Math.round(renderedHeight);
      renderedWidth = Math.round(renderedWidth);
      if (renderedHeight !== height || renderedWidth !== width) {
        setWidth(renderedWidth);
        setHeight(renderedHeight);
      }
    }
  }, [width, height]);
  const padding = 10;
  const paddedWidth = width + padding * 2;
  const paddedHeight = height + padding * 2;
  return /* @__PURE__ */ React__default.createElement("g", null, /* @__PURE__ */ React__default.createElement(
    "rect",
    {
      className: classes.node,
      width: paddedWidth,
      height: paddedHeight,
      rx: 10
    }
  ), /* @__PURE__ */ React__default.createElement(
    "text",
    {
      ref: idRef,
      className: classes.text,
      y: paddedHeight / 2,
      x: paddedWidth / 2,
      textAnchor: "middle",
      alignmentBaseline: "middle"
    },
    id
  ));
}

export { DefaultNode };
//# sourceMappingURL=DefaultNode.esm.js.map
